export const submissionStatusStyles = {
  lineFieldset: {
    position: "relative",
    border: "1px solid #999",
    borderRadius: 4,
    padding: "10px 44px 10px 14px",
    background: "#fff",
    cursor: "pointer",
  },
  lineFloatLabel: {
    position: "absolute",
    top: -9,
    left: 10,
    background: "#fff",
    padding: "0 4px",
    fontSize: "0.75rem",
    color: "#666",
    lineHeight: 1,
  },
  lineSelect: {
    border: "none",
    outline: "none",
    width: "100%",
    fontSize: "1rem",
    background: "transparent",
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    cursor: "pointer",
    color: "#111",
    fontWeight: 500,
    textAlign: "left",
    padding: 0,
  },
  lineDropdownPanel: {
    position: "absolute",
    top: "calc(100% + 4px)",
    left: 0,
    right: 0,
    maxHeight: 240,
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
    background: "#fff",
    border: "1px solid #999",
    borderRadius: 4,
    boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
    margin: 0,
    padding: "4px 0",
    listStyle: "none",
    zIndex: 100,
  },
  lineDropdownOption: {
    padding: "12px 14px",
    cursor: "pointer",
    fontSize: "1rem",
    color: "#111",
    WebkitTapHighlightColor: "rgba(0,0,0,0.06)",
  },
  lineDropdownOptionActive: {
    background: "#f0f0f0",
    fontWeight: 600,
  },
  lineDropdownOptionHighlighted: {
    background: "#e6e6e6",
  },
  selectArrow: {
    position: "absolute",
    right: 14,
    top: "50%",
    transform: "translateY(-50%)",
    pointerEvents: "none",
    fontSize: "0.75rem",
    color: "#555",
  },
  sectionHeader: {
    fontSize: "1.2rem",
    fontWeight: 700,
    color: "#111",
    marginBottom: 4,
  },
  emptyState: {
    color: "#666",
    padding: "24px 0",
  },
  rebateList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
  },
  rebateItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 4px",
    borderBottom: "1.5px solid #bebebe",
    cursor: "pointer",
    background: "transparent",
  },
  rebateContent: {
    flex: 1,
    minWidth: 0,
  },
  rebateTitle: {
    fontWeight: 700,
    fontSize: "0.95rem",
    color: "#111",
    marginBottom: 2,
  },
  rebateValue: {
    fontSize: "0.85rem",
    color: "#555",
    marginBottom: 7,
  },
  badge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "3px 10px",
    borderRadius: 20,
    fontSize: "0.8rem",
    fontWeight: 600,
    whiteSpace: "nowrap",
  },
  badgeDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    flexShrink: 0,
  },
  chevron: {
    fontSize: "1.6rem",
    color: "#999",
    marginLeft: 12,
    lineHeight: 1,
    flexShrink: 0,
  },
}
